import React from 'react';
import {
  HomeMainPCHeader,
  HomeMainPCList,
  HomeMainPCHelpDesk,
} from '@container/home/main/mainPC';

const HomeMainPC = () => {
  return (
    <>
      <div className="app-box-main">
        <HomeMainPCHeader />
        <HomeMainPCList />
      </div>

      <HomeMainPCHelpDesk />
    </>
  );
};

export default HomeMainPC;
